/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fresh_Free_Crane_RushInputs */

const en_fresh_free_crane_rush = /** @type {(inputs: Fresh_Free_Crane_RushInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SMS message`)
};

const de_fresh_free_crane_rush = /** @type {(inputs: Fresh_Free_Crane_RushInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SMS-Nachricht`)
};

/**
* | output |
* | --- |
* | "SMS message" |
*
* @param {Fresh_Free_Crane_RushInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const fresh_free_crane_rush = /** @type {((inputs?: Fresh_Free_Crane_RushInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fresh_Free_Crane_RushInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_fresh_free_crane_rush(inputs)
	return de_fresh_free_crane_rush(inputs)
});